import React, { FC } from 'react';
import { parseProcessName } from '~/utils';
import {
  Button,
  Content,
  Description,
  Title,
  WrapperButtons,
} from '~/components/CardProcess/card.styles';

type Props = {
  title: string;
  description: string;
  onEditPress: () => void;
  onDelete: () => void;
  onExecute?: () => void; 
  editMode?: boolean;
  titleBtn?: string;
};

const CardProcessConfig: FC<Props> = ({
  title,
  description,
  onEditPress,
  onDelete,
  onExecute,
  editMode = true,
  titleBtn = 'Executar',
}) => (
  <Content>
    <Title>{parseProcessName(title)}</Title>
    <Description>{description.replaceAll('_', ' ')}</Description>

    <WrapperButtons>
      {onExecute && !editMode && ( 
        <Button onClick={onExecute} fullWidth>
          {titleBtn}
        </Button>
      )}
      {editMode && (
        <>
          <Button onClick={onEditPress}>Editar</Button>
          <Button onClick={onDelete} color="secondary">
            Excluir
          </Button>
        </>
      )}
    </WrapperButtons>
  </Content>
);

export default CardProcessConfig;
